export default __webpack_public_path__ + "e4f8bbf8a27bb5a23dc91ef8e783b284.png";